const getPageFirstList = vm => window.magicPageFirstViewList && window.magicPageFirstViewList[vm.app.pageConfig.name];

const getPageList = vm => window.magicPageViewList && window.magicPageViewList[vm.app.pageConfig.name];

const splice = (list, id) => {
  if (list && list.length) {
    const index = list.findIndex(v => v === id);
    if (index > -1) {
      list.splice(index, 1);
    }
  }
};

const pageReadyEmit = (v, viewList, page) => {
  const vm = v;
  if (vm.app.isInMagicPageRender[page] && !viewList.length) {
    vm.app.isInMagicPageRender[page] = false;
    vm.app.$emit('magic-page-view-ready', vm.app);
    vm.$bus.$emit('magic-page-view-ready', vm.app);
    console.log('tag all mounted');
  }
};

// 某些不知原因情况下本文件的 export default 混入没有成功注册到组件里
// mounted 不执行导致列表未被清除，需要定时器清理，保证全局挂载完成的 promise resolve
window.magicPageViewReadyTimer = window.pageViewReadyTimer || null;
const setTimer = (vm) => {
  if (window.pageViewReadyTimer) clearTimeout(window.pageViewReadyTimer);

  window.pageViewReadyTimer = setTimeout(() => {
    const viewList = getPageList(vm);
    if (viewList && viewList.length) {
      viewList.splice(0);
      pageReadyEmit(vm, viewList, vm.app.pageConfig.name);
    }
  }, 2000);
};

// 清除首屏组件列表
const spliceFirstViewList = (vm, remove, handlerFunc) => {
  const firstViewList = getPageFirstList(vm);
  const page = vm.app.pageConfig.name;
  if (vm.app.isInMagicFirstViewRender[page] && firstViewList && firstViewList.length) {
    if (vm.config.inMagicFirstView) {
      if (remove) {
        // 如果在首屏组件中，显示的设置为 true，不显示的从首屏列表中删除
        splice(firstViewList, vm.config.id);
      }

      typeof handlerFunc === 'function' && handlerFunc.call(vm, firstViewList, page);
    } else {
      return false;
    }
  }

  return true;
};

// 清除全局组件列表
const splicePageViewList = (vm, remove, handlerFunc) => {
  const viewList = getPageList(vm);
  const page = vm.app.pageConfig.name;
  if (vm.app.isInMagicPageRender[page] && viewList && viewList.length && remove) {
    // 不显示的从全局列表中删除
    splice(viewList, vm.config.id);

    typeof handlerFunc === 'function' && handlerFunc.call(vm, viewList, page);
  }
};

export function processPageRender(vm) {
  if (window.magicPageViewList) {
    const { name } = vm.config;
    const { isInMagicFirstViewRender, isInMagicPageRender, magicPageViewPromise } = vm.app;
    typeof isInMagicFirstViewRender[name] === 'undefined' && vm.$set(isInMagicFirstViewRender, name, true);
    typeof isInMagicPageRender[name] === 'undefined' && vm.$set(isInMagicPageRender, name, true);
    typeof magicPageViewPromise[name] === 'undefined' && vm.$set(magicPageViewPromise, name, new Promise((resolve) => {
      vm.app.$on('magic-page-view-ready', () => {
        resolve();
      });
    }));
  }
}

// magic-ui-component render函数的前置处理
// 如果组件不显示，从对应的两个列表中去掉隐藏的组件
// 如果有首屏标记但是不在首屏的组件
export function spliceNotRenderComponent(vm, display) {
  splicePageViewList(vm, !display);
  return spliceFirstViewList(vm, !display);
}

// magic-ui-container render 函数的前置处理
// 如果 container 不显示，需要把 container 下的所有组件从两个（首屏/全局）列表中清空
export function spliceNotRenderContainer(vm, config) {
  const viewList = getPageList(vm);
  const page = vm.app.pageConfig.name;
  if (!(vm.app.isInMagicPageRender[page] && viewList && viewList.length)) {
    return;
  }
  if (config.items && config.items.length) {
    config.items.forEach((v) => {
      splice(getPageFirstList(vm), v.id);
      splice(viewList, v.id);
      if (v.items) {
        spliceNotRenderContainer(vm, v);
      }
    });
  }
}

export default {
  mounted() {
    // 首屏渲染代码
    spliceFirstViewList(this, true, (firstViewList, page) => {
      if (this.app.isInMagicFirstViewRender[page] && !firstViewList.length) {
        this.app.isInMagicFirstViewRender[page] = false;
        this.app.$emit('magic-first-view-ready', this.app);
        this.$bus.$emit('magic-first-view-ready', this.app);
        console.log('tag first mounted');
      }
    });

    splicePageViewList(this, true, (viewList, page) => {
      pageReadyEmit(this, viewList, page);
    });
    setTimer(this);
  },
};
